/**
 * 路由白名单配置
 * 这些路径不需要登录即可访问
 */
export type RouteWhiteListRule = string | RegExp | { type: 'prefix'; value: string };

export const ROUTE_WHITE_LIST: RouteWhiteListRule[] = [
  '/', //根路径自动根据权限做动态重定向，直接放行，避免跳转/404
  '/login',
  '/activate',
  '/404',
];

export function isWhiteListed(pathname: string) {
  return ROUTE_WHITE_LIST.some((rule) => {
    if (typeof rule === 'string') {
      return pathname === rule;
    }
    if (rule instanceof RegExp) {
      return rule.test(pathname);
    }
    return pathname.startsWith(rule.value);
  });
}
